import styled, { createGlobalStyle } from 'styled-components'

export const LoginGlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    width: 100vw;
    height: 100vh;
    background: rgb(255, 255, 255);
  }
`

export const Login = styled.div`
  background: ${({ theme }) => theme.webMktNewPalette.white};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 350px;
  width: 550px;
  box-shadow: 11px 10px 31px -3px rgba(0, 0, 0, 0.51);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h1 {
    margin: 0 0 24px;
  }

  p {
    position: absolute;
    color: red;
    margin: 0;
    padding: 16px;
    bottom: 0;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 24px;
  }

  input {
    font-size: 16px;
    width: 250px;
    padding: 16px;
    border: 1px solid black;
  }

  img {
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    transform: translate(50%, -50%);
  }

  .Login-Submit {
    margin-top: 24px;
    height: 53px;
    font-size: 18px;
  }

  button {
    transition: all 0.1s cubic-bezier(0.4, 0, 0.2, 1) 0s;
    border-radius: 0px;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    padding: 12px 24px;
    background: ${({ theme }) => theme.webMktNewPalette.orange[50]};
    color: ${({ theme }) => theme.webMktNewPalette.white};
    height: 53px;
    display: inline-flex;
    flex-direction: row;
    align-items: center;

    &:hover {
      background: ${({ theme }) => theme.webMktNewPalette.black};
    }

    &:disabled {
      &:hover {
        background: ${({ theme }) => theme.webMktNewPalette.orange[50]};
      }
      opacity: 0.6;
    }
  }
`

export const Logout = styled.a`
  position: fixed;
  top: 0;
  right: 0;
  padding: 16px;
  background: #fff;
  z-index: 100;
  opacity: 0;
  transition: all 0.3s linear;
  color: ${({ theme }) => theme.webMktNewPalette?.black};

  &:hover {
    opacity: 1;
  }
`
